export enum Page {
    Dashboard = "dashboard",
    DashboardOld = "dashboardOld",
    SupervisorList = "supervisorList",
    EmployeeList = "employeeList",
    TimeSheetPage = "timeSheetPage",
    PaycorDownload = "paycorDownload",
    ManualPaycor = "manualPaycor",
    V1Supervisors= "v1Supervisors",
    V2Supervisors= "v1Supervisors",
    V1Employees= "v1Employees",
    V2Employees= "v2Employees",
    WCDPPaintSingleFamilyImport = "wcdpPaintSingleFamilyImport",
    WCDPPaintMultiFamilyImport = "wcdpPaintMultiFamilyImport",
    WCDPPaintMultiFamilyImportV1 = "wcdpPaintMultiFamilyImportV1",
    WCDPDrywallSingleFamilyImport = "wcdpDrywallSingleFamilyImport",
    WCDPDrywallMultiFamilyImport = "wcdpDryallMultiFamilyImport",
    EmployeeView = "employeeView",
    PayPeriods = "payPeriods",
    RolePage = "rolePage",
    AdminEmployeeView = "adminEmployeeView",
    AdminManagement = "adminManagement",
    Locations = "locationsPage",
    AccountCode = "accountCodePage",
    V1BatchExport = 'v1BatchExport',
    V2BatchExport = 'v2BatchExport',
    VistaExport = "vistaExport",
    PaycorDownloadV2 = "paycorDownloadV2",
    PaycorPrdaLocal = "paycorPrdaLocal",
    PrdaMonthlyReports = "prdaMonthlyReports",
    MiscellaneousTasks = "miscellaneousTasks",
    Reports = "reportsPage",
    AttendanceReport = "attendanceReport",
    TimesheetDeadlineReport = "timesheetDeadlineReport",
    WeeklyOpsReport = "weeklyOpsReport",
    ModifiedDuty = "modifiedDuty",
    Projects = "projects",
    Comments = "comments",
    /** TAS-123 — supersedes Comments; a comment is one kind of exception. */
    TimesheetExceptions = "timesheetExceptions",
    /** WCDP payroll — everyone with approved/pending sick time in the week (read-only). */
    SickHours = "sickHours",
    /** NPM payroll — who worked a Los Angeles job this year vs. Vista CA LA SICK (read-only). */
    LaSick = "laSick",
    AuditReport = "auditReport",
    /** v2 Reports hub. Distinct from `Reports` (WCDP's Daily Payroll page) and
     *  `ReportsConfiguration` (the external report engine's config page) — three
     *  different things are called "Reports"; do not conflate them. */
    ReportsHub = "reportsHub",
    PieceImport = "pieceImport",
    RiceServicesPieceImport = "riceServicesPieceImport",
    /** UPF phase-budget PDF piece import (shared WcdpProjectImport page, variant upfPiecePdf). */
    UPFPieceBudgetImport = "upfPieceBudgetImport",
    PWFringeTypes = "pwFringeTypes",
    PWClassifications = "pwClassifications",
    PWProjectSetup = "pwProjectSetup",
    SyncStatus = "syncStatus",
    SelfieVerificationExceptions = "selfieVerificationExceptions",
    TimeOffConfiguration = "timeOffConfiguration",
    ProcessPayroll = "processPayroll",
    UnionWages = "unionWages",
    ProjectMap = "projectMap",
  TimeOffRequestApproval = "timeOffRequestApproval",
  TimesheetReview = "timesheetReview",
  /** Payroll Timesheet Modifications — the M2 payroll editor route (M1-B3 registers
   *  the stub; M2-B1 replaces the body with the day-by-day editor). */
  PayrollTimesheetEdit = "payrollTimesheetEdit",
  GpsExceptions = "gpsExceptions",
  ReportsConfiguration = "reportsConfiguration",
  /** TAS-128 Weekly Safety Message — one message per pay period, delivered to the
   *  mobile app as a Home tile and a first-clock-in popup. */
  SafetyMessage = "safetyMessage",
  /** TAS-585 Kiosk Devices — admin-managed kiosk tablets enrolled with one-time codes. */
  KioskDevices = "kioskDevices",
  ProjectWork = "projectWork",
  CrewWork = "crewWork",
    WorkOrders = "workOrders",
    WorkOrderDetail = "workOrderDetail",
    ChangeOrders = "changeOrders",
    ChangeOrderCreate = "changeOrderCreate",
    ChangeOrderDetail = "changeOrderDetail",
    CustomerContacts = "customerContacts",
  /** Employee Time Portal (P-TAS-20 Phase 3) — the "My Time" pages, routed only in the
   *  employee experience (App.tsx). Today is App-1; the other three land in App-2..4. */
  MyToday = "myToday",
  MyTimesheet = "myTimesheet",
  MyTimeOff = "myTimeOff",
  MyActivity = "myActivity",
  }
  